import { useState } from 'react';
import { createHookContext } from '@clover-util/react-context';
import { useCart } from 'hooks/context/cart';
import { useGiftCardCart } from 'hooks/context/giftCardCart';
import { useMerchant } from 'hooks/context/merchant';
import { useMerchantState } from 'hooks/context/MerchantState';
import { useRunningOrder } from 'hooks/context/RunningOrder';
import { isOnlyIpgProcess, isPaymentProcessorIpg } from 'util/IpgPay';
import { useOrderTotals } from 'routes/Checkout/context/useOrderTotals';

export const { CheckoutValidityProvider, useCheckoutValidity } = createHookContext( 'CheckoutValidity', () => {
  const { isAcceptingOrders } = useMerchantState();
  const { merchant } = useMerchant();
  const { itemCount: cartItemCount } = useCart();
  const { itemCount: giftCartCount } = useGiftCardCart();
  const runningOrder = useRunningOrder();
  const itemCount = cartItemCount + giftCartCount;
  const hasItemsInCart = itemCount > 0;
  const validGiftCardOnlyOrder = cartItemCount === 0 && giftCartCount > 0 && merchant?.onlineServices?.GIFT_CARDS?.enabled;

  const isIpg = isPaymentProcessorIpg(merchant?.paymentMethods);
  const isOnlyIpg = isOnlyIpgProcess(merchant?.paymentMethods);
  const [isContactFormDataValid, setContactFormValidity] = useState(false);

  const [isPaymentFormValid, setPaymentFormValidity] = useState(false);

  const { totalWithTip } = useOrderTotals();

  const isCheckoutValid = (!isAcceptingOrders ? validGiftCardOnlyOrder : (hasItemsInCart || runningOrder.hasItems)) && isContactFormDataValid;

  let isOrderValid = isCheckoutValid;
  if (!isIpg) {
    isOrderValid = isOrderValid && ( totalWithTip === 0 || isPaymentFormValid);
  }

  return {
    setContactFormValidity,
    setPaymentFormValidity,
    isContactFormDataValid,
    isCheckoutValid,
    isOrderValid,
    isOnlyIpg,
    validGiftCardOnlyOrder,
    isPaymentFormValid,
  };
});
